import * as ol from 'openlayers';
import appConfig from '../../config/app_config';
import store from '../store.js';

export default class MapObject {
  constructor(properties) {
    if (store.getters['locations/getCenterPointForMap'].length !== 0) {
      this.centerPoint = store.getters['locations/getCenterPointForMap'];
    } else {
      this.centerPoint = appConfig.map.center;
    }

    const tileLayer = new ol.layer.Tile({
      source: new ol.source.OSM({
        url: appConfig.tileServer.url, // Tile server from TDF initialised
        crossOrigin: null, // TODO set the correct comment
      }),
    });
    const overlayElement = document.getElementById('popup');
    const overlay = new ol.Overlay({
      element: overlayElement,
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    // Creating the initial map
    this.map = new ol.Map({
      layers: [tileLayer],
      overlays: [overlay],
      target: properties.name,
      view: new ol.View({
        center: ol.proj.fromLonLat([this.centerPoint[0], this.centerPoint[1]]),
        zoom: properties.view.zoom,
        minZoom: appConfig.map.minZoom,
        maxZoom: appConfig.map.maxZoom,
      }),
      // Creating the initial interactions for the map
      interactions: ol.interaction.defaults({
        doubleClickZoom: properties.interactions.doubleClickZoom,
        dragAndDrop: properties.interactions.dragAndDrop,
        dragPan: properties.interactions.dragPan,
        keyboardPan: properties.interactions.keyboardPan,
        keyboardZoom: properties.interactions.keyboardZoom,
        mouseWheelZoom: properties.interactions.mouseWheelZoom,
        pointer: properties.interactions.pointer,
        select: properties.interactions.select,
      }),
      controls: ol.control.defaults({
        attribution: properties.controls.zoomControls,
        zoom: false,
      }),
    });
    if (properties.controls.zoomControls) {
      this.map.addControl(new ol.control.Attribution());
    }
    this._showPointerOnFeatureHover();
  }

  _updateCenterPoint(coordinates) {
    this.map
      .getView()
      .setCenter(ol.proj.transform(coordinates, 'EPSG:4326', 'EPSG:3857'));
  }

  _showPointerOnFeatureHover() {
    const self = this;
    this.map.on('pointermove', function(e) {
      let pixel = self.map.getEventPixel(e.originalEvent);
      let hit = self.map.hasFeatureAtPixel(pixel);
      self.map.getViewport().style.cursor = hit ? 'pointer' : '';
    });
  }

  selfDestruct() {
    this.map.setTarget(null);
  }

  addLayerOnMap(vectorLayer) {
    this.map.addLayer(vectorLayer);
  }

  enableClick() {
    // enable click on the map
    const self = this;
    let clickPoint = '';
    this.disableWaypointInteraction = false;
    this.map.on('click', function(evt) {
      // Get the pointer coordinate
      let mousePositionCoordinate = ol.proj.transform(
        evt.coordinate,
        'EPSG:3857',
        'EPSG:4326',
      );
      mousePositionCoordinate[0] = mousePositionCoordinate[0].toFixed(6);
      mousePositionCoordinate[1] = mousePositionCoordinate[1].toFixed(6);
      clickPoint = mousePositionCoordinate.join();
      self.map.removeEventListener('click');
    });
    return clickPoint;
  }

  removeClickEvent() {
    this.map.removeEventListener('click');
  }

  deleteLayer(name) {
    this.map
      .getLayers()
      .getArray()
      .filter((layer) => layer.get('name') === name)
      .forEach((layer) => this.map.removeLayer(layer));
  }

  focusOnPolyline(polylineArray, padding = [0, 0, 0, 0]) {
    let polyline = new ol.geom.LineString(polylineArray);
    polyline.transform('EPSG:4326', 'EPSG:3857');
    this.map.getView().fit(polyline, {padding});
  }
  focusOnCoordinate(lonLat, zoom) {
    const coordinate = ol.proj.fromLonLat(lonLat);
    const duration = 700;
    const initialZoom = this.map.getView().getZoom();
    this.map.getView().animate({
      center: coordinate,
      duration: duration,
    });
    this.map.getView().animate(
      {
        zoom: initialZoom - 1,
        duration: duration / 2,
      },
      {
        zoom: zoom,
        duration: duration / 2,
      },
    );
  }

  static createCategoryMarker(marker) {
    const iconFeature = new ol.Feature({
      geometry: new ol.geom.Point(
        ol.proj.transform(
          [marker.longitude, marker.latitude],
          'EPSG:4326', 'EPSG:3857',
        ),
      ),
      coordinates: [marker.longitude, marker.latitude],
      data: marker.data,
      // data: {
      //   name: element.Name,
      //   description: element.Description,
      //   locationId: element.Id,
      //   locationTags: toStoreCategories,
      // },
    });
    // window.EventBus.fire('checkIfImageExist', marker.category);
    if(marker.category === '' || marker.category == undefined) marker.category = 'POI';
    const iconStyle = new ol.style.Style({
      image: new ol.style.Icon({
        anchor: [0.5, 1],
        src: marker.category,
        scale: 0.5,
      }),
    });
    iconFeature.setStyle(iconStyle);
    return iconFeature;
  }

  static createDotMarker(marker, color, radius, text, textColor, zIndex) {
    const iconFeature = new ol.Feature({
      geometry: new ol.geom.Point(
        ol.proj.transform(
          [marker.longitude, marker.latitude],
          'EPSG:4326', 'EPSG:3857',
        ),
      ),
      coordinates: [marker.longitude, marker.latitude],
      data: marker.data,
    });
    let iconStyle = {}

    if (text === '') {
      iconStyle = new ol.style.Style({
        image: new ol.style.Circle({
          radius: radius,
          fill: new ol.style.Fill({
            color: color,
          }),
        }),
      });
    } else {
      iconStyle = new ol.style.Style({
        image: new ol.style.Circle({
          radius: radius,
          fill: new ol.style.Fill({
            color: color,
          }),
        }),
        text: new ol.style.Text({
          text: text,
          offsetY: 0,
          scale: 1,
          fill: new ol.style.Fill({
            color: textColor,
          }),
        }),
        zIndex: zIndex,
      });
    }
    iconFeature.setStyle(iconStyle);
    return iconFeature;
  }

  static createPolyline(polylineArray, color, width) {
    const polyline = new ol.geom.LineString(polylineArray);
    polyline.transform('EPSG:4326', 'EPSG:3857');

    let polylineFeature = new ol.Feature({
      geometry: polyline,
      coordinates: false,
    });

    const polylineStyle = new ol.style.Style({
      stroke: new ol.style.Stroke({
        color: color,
        width: width,
      }),
    });
    polylineFeature.setStyle(polylineStyle);
    return polylineFeature;
  }

  static createVectorSource(features) {
    return new ol.source.Vector({
      features: features,
    });
  }

  static createVectorLayer(name, vectorSource) {
    return new ol.layer.Vector({
      source: vectorSource,
      name: name,
    });
  }
}
